import React from "react";
import "./Quiz.css";

const Result = ({ score, total, userAnswers = [], onRestart }) => {
  const accuracy = Math.round((score / total) * 100);

  let badgeLabel = "Beginner";
  let badgeClass = "badge-beginner";

  if (accuracy >= 80) {
    badgeLabel = "Expert";
    badgeClass = "badge-expert";
  } else if (accuracy >= 50) {
    badgeLabel = "Intermediate";
    badgeClass = "badge-intermediate";
  }

  return (
    <div className="glass-card result-card">
      {/* HEADER */}
      <div className="result-header">
        <h2 className="result-title">Quiz Completed 🎉</h2>

        <p className="result-score">
          You scored <strong>{score}</strong> out of <strong>{total}</strong>
        </p>

        <p className="result-accuracy">
          Accuracy: <strong>{accuracy}%</strong>
        </p>
      </div>

      {/* ✅ BADGE WRAPPER (STEP 1) */}
      <div className="result-badges">
        <div className={`score-badge ${badgeClass}`}>
          {badgeLabel} · {accuracy}%
        </div>
      </div>

      {/* SCROLLABLE REVIEW AREA */}
      <div className="result-scroll">
        {userAnswers.length === 0 ? (
          <p className="result-empty">No answers to review.</p>
        ) : (
          userAnswers.map((item, index) => (
            <div
              key={index}
              className={`result-item ${
                item.isCorrect ? "correct" : "wrong"
              }`}
            >
              <div className="result-item-header">
                <span className="result-question">
                  Q{index + 1}. {item.question}
                </span>
                <span className="result-icon">
                  {item.isCorrect ? "✔" : "✖"}
                </span>
              </div>

              <div className="result-line">
                <span className="label">Your answer:</span>
                <span className="value">
                  {Array.isArray(item.userAnswer)
                    ? item.userAnswer.join(", ")
                    : item.userAnswer || "—"}
                </span>
              </div>

              {!item.isCorrect && (
                <div className="result-line">
                  <span className="label">Correct:</span>
                  <span className="value">
                    {Array.isArray(item.correctAnswer)
                      ? item.correctAnswer.join(", ")
                      : item.correctAnswer}
                  </span>
                </div>
              )}
            </div>
          ))
        )}
      </div>

      {/* FOOTER */}
      <button className="restart-btn" onClick={onRestart}>
        Restart Quiz
      </button>
    </div>
  );
};

export default Result;
